import { Component, Input, EventEmitter, Output } from '@angular/core';
import { pillStyles, PillProps } from '@kite_aerolab/shared/components';
import { closeActionHighlighted } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-pill',
  template: `
    <button [ngClass]="pillStyles" class="is-button" (click)="onClick.emit($event)">
      <kite-icon [name]="icon" *ngIf="icon"></kite-icon>
      <ng-content></ng-content>
      <kite-close-action *ngIf="isRemovable && isActive" [css]="closeActionHighlighted" ></kite-close-action>
    </button>
  `,
})
export class PillComponent implements PillProps {
  /**
   * Tamaño del pill: sm, md o lg
   */
  @Input() size: PillProps['size'];

  /**
   * Indicador de si el pill está deshabilitado
   */
  @Input() isDisabled: PillProps['isDisabled'];

  /**
   * indicador de si el pill está activo
   */
  @Input() isActive: PillProps['isActive'];

  /**
   * indicador de si el pill es removible (le agrega el botón de close)
   */
  @Input() isRemovable: PillProps['isRemovable'];

  /**
   * CSS del componente
   */
  @Input() css: PillProps['css'];

  /**
   * ícono del pill
   */
  @Input() icon: PillProps['icon'];

  @Output()
  onClick = new EventEmitter<Event>();

  public get pillStyles(): string[] {
    return [
      pillStyles({
        size: this.size,
        isDisabled: this.isDisabled,
        isActive: this.isActive,
        isRemovable: this.isRemovable,
        css: this.css,
      }).className,
    ];
  }

  public get closeActionHighlighted(): any {
    return closeActionHighlighted;
  }
}
